module.exports = __webpack_public_path__ + "img/failed.cdcd6484.png";